const baseValidPaths = [
  "/",
  "/country-master",
  "/state-master",
  "/city-master",
  "/city-details",
  "/organization-zone",
  "/zone-details",
  "/organization-circle",
  "/circle-details",
  "/organization-colony",
  "/organization-ward",
  "/ward-details",
  "/vehicles",
  "/vehicles-v1",
  "/view-vehicle-details",
  "/vehicle-type",
  "/container-type",
  "/vehicle-type-details",
  "/owner-type",
  "/owner-type-details",
  "/collection-type",
  "/roles",
  "/users",
  "/scv-drivers",
  "/driver-details",
  "/loading-equipment",
  "/shifts",
  "/view-shift-details",
  "/collection-points",
  "/view-collection-points-details",
  "/route-master",
  "/route-summary-path",
  "/route-master-details",
  "/transferStation",
  "/transferstation-incharge",
  "/transfer-station-details",
  "/Containers",
  "/container-details",
  "/deployment-locations",
  "/deployment-location-details",
  "/primary-deployment-charge-master",
  "/secondary-deployment-incharges",
  "/deployment-charge-details",
  "/companies",
  "/company-details",
  "/reports",
  "/vehicle-total-weightment",
  "/live-reports",
  "/live-inner-reports",
  "/summary-reports",
  "/unloading-wait-time",
  "/route-tracking",
  "/transfer-station-detail-report",
  "/scv-deployed-trips",
  "/scv-driver-data",
  "/overall-trips-ts/sctp",
  "/scv-master-data",
  "/gvp-report",
  "/gvp-master",
  "/gvp-clearance-report",
  "/gvp-clearence-report-old",
  "/gvp-multiple-clearence",
  "/gvp-day-clearence",
  "/gvp-not-clearence",
  "/gvp-route-map",
  "/trips-tonnage-reports",
  "/ts_sctp_trips_tonnage",
  "/trip_tonnage_detail_report",
  "/ts_sctp_ulb",
  "/hook_loader_report",
  "/container_report",
  "/primary-dashboard",
  "/teritary-dashboard",
  "/vehicle_hook",
  "/day_detail_report",
  "/not_report_ward",
  "/daywise_not_report",
  "/week_daywise_pendency",
  "/report_at_ward",
  "/vehicle_master_report",
  "/tssctp_wise_report",
  "/deviation_report",
  "/trip_tssctp",
  "/scv_report_circle",
  "/scv_route_tracking",
  "/tssctp_view",
  "/vehicle-capacity",
  "/container-capacity",
  "/transaction-reports",
  "/primary-deployment-transaction-report",
  "/traffic-marshal-transaction-report",
  "/secondary-deployment-transaction-report",
  "/deployed-hookloader-report",
  "/secondary-collection-transaction",
  "/deployed-container-transaction",
  "/all-transferstation-transaction",
  "/container-hookloader-transaction",
  "/geofence-summary",
  "/geofence-vehicle-reports",
  "/deployed-trips-tssctp",
  "/view-scvs-circle-report",
  "/view-inner-scv-circle-report",
  "/view-overall-trips",
  "/view-gvp-clearence",
  "/multi-clearence--inner-report",
  "/multi-clearence-existing-gvp-inner-report",
  "/multi-clearence-gvp-inner-report",
  "/gvp-inner-circle-report",
  "/view-sat-zone-report",
  "/view-sat-vehicle-report",
  "/reported-ward-zone",
  "/view-vehicle-inner-report",
  "/sat-under-repair-report",
  "/sat-active-report",
  "/sat-total-report",
  "/gvp-inner-existing-report",
  "/gvp-inner-cleared-report",
  "/sat-circle-total-report",
  "/circle-condemned-report",
  "/circle-under-repair-report",
  "/circle-active-report",
  "/view-deployed-trips",
  "/cumulative-operation",
  "/view-Gvp-clearence-report",
  "/reported-ts-notward-zone",
  "/reported-ts-notward-circle",
  "/reported-ward-circle",
  "/reported-wardts-zone",
  "/reported-wardts-circle",
  "/not-reported-ward-zone",
  "/not-reported-ward-circle",
  "/reported-ward-notts-zone",
  "/reported-ward-notts-circle",
  "/gvp-dashboard",
  "/contractor-wise-report",
  "/sat-dashboard",
  "/scv-dashboard",
  "/sat-inactive-report",
  "/circle-inactive-report",
  "/geofence-vehicle-summary-reports",
  "/scv-circle-reported-vehicle-rcv",
  "/scv-circle-not-reported-rcv",
  "/view-circle-inner-vehicle-alloted-rcv",
  "/view-circle-inner-collection-point-trans",
  "/loading_equipment_clearence-report",
  "/loading_equipment_certification-report",
  "/loading_equipment_inner_certification-report",
  "/zone-trips-tonnage",
  "/zone-container_report",
  "/zone-hookloader_report",
  "/vehicle-hookloader_report",
  "/ghmc-trips-tonnage",
  "/hire-trips-tonnage",
  "/himsw-trips-tonnage",
  "/total-trips-tonnage",
  "/ghmc-tonnage",
  "/hire-tonnage",
  "/himsw-tonnage",
  "/total-tonnage",
  "/zone-ulb",
  "/mobile-apk's",
  "/traffic-marshal",
  "/loading-equipment-driver-details",
  "/loading_equipment_deployment-summary-report",
  "/loading_equipment_clearance-report",
  "/sat-circle-total-wise-report",
  "/circle-condemned-circle-report",
  "/circle-under-repair-total-report",
  "/circle-inactive-total-report",
  "/circle-active-total-report",
  "/reported-ward-circle-total",
  "/not-reported-ward-circle-total",
  "/reported-wardts-circle-total",
  "/reported-ward-notts-circle-total",
  "/reported-ts-notward-circle-total",
  "/gvp-report-date",
  "/tertiary-deployment-details",
  "/tertiary-trip-details",
  "/deployment-summary",
  "/deployment-report-teritary",
  "/trip-report-teritary",
  "/summary-report-teritary",
  "/inner-teritory-deployedts",
  "/inner-teritory-deployedJN",
  "/inner-teritory-hatling-report",
  "/inner-teritory-total-deployment",
  "/active-users",
  "/gvp-clearance-map-view",
  "/gvp-clearance-pending-report",
  "/gvp-hotspot-clearance-report",
  "/gvp-clearance-view-report",
  "/gvp-collection-report",
  "/sat-total-inner-trip-report",
  "/sat-inner-trip-report",
  "/sat-inner-circle-report",
  "/sat-inner-circle-zone-report",
  "/ts-feedback-category",
  "/hygiene-observation",
  "/independent-engineer",
  "/grievance-detailed-report",
  "/attendance-summary-report",
  "/attendance-daily-report",
  "/employee",
  "/operations",
  "/designations",
  "/month-wise-attendance-summary-report",
  "/zone-level-drill-down",
  "/supporting-staff-drill-down",
  "/tipping-fee",
  "/tipping-fee-calculation-report",
  "/inner-tipping-fee-calculation-report",
  "/tonnage-composition-report",
  "/hygiene-transportation-report",
  "/frequency-bins-report",
  "/inner-frequency-bins-report",
  "/msw-management-vehicles-report",
  "/msw-management-vehicles-inner-report",
  "/gvp-not-cleared-inner-report",
  "/gvp-inner-cleared-not-shift-report",
  "/gvp-total-cleared-inner-report",
  "/route-supervisor",
  "/horticulture-collection-transportation-report",
  "/drainslit-C&T-transportation-report",
  "/animalcar-C&T-transportation-report",
  "/DHW-C&T-transportation-report",
  "/bin-clear-disinfection-transportation-report",
  "/trips-tonnage-report",
  "/inner-tonnage-report",
  "/primary-collection-report",
  "/secondary-collection-report",
  "/commercial-collection-report",
  "/route-point-transaction-report",
  "/complaint-report",
  "/ie-issue",
  "/conditions-of-dhalao-report",
  "/conditions-of-fixed-compacting-stations-report",
  "/conditions-of-street-corner-bins-report",
  "/conditions-of-mobile-transfer-stations-report",
  "/conditions-of-auto-tippers-report",
  "/conditions-of-refuse-collector-transport-vehicles-report",
  "/conditions-of-hook-loader-vehicles-report",
  "/primary-vehicle-deploy-report",
  "/ward-coverage-report",
  "/rc-deployment-report",
  "/rc-inner-report",
  "/trip-to-fcts-report",
  "/overview-of-secondary-collection-point-report",
  "/overview-of-secondary-collection-point-inner-report",
  "/hook-loader-report",
  "/hook-loader-inner-report",
  "/vehicle-coverage-report",
  "/vehicle-cleared-points-report",
  "/vehicle-balance-points-report",
  "/iec-activity-report",
  "/rfid-reports",
  "/hand-held-reader-collection",
];

export const createValidPaths = (additionalPaths = []) =>
  Array.from(new Set([...baseValidPaths, ...additionalPaths]));
